import { resetPledgePayOpenCredit } from './pledge-pay-open-credit-context';

let pledgePayMemberContext = {
    userId: null,
    hasSavedCards: false,
    savedCards: [],
};

function resetPledgePayMemberContext() {
    pledgePayMemberContext = {
        userId: null,
        hasSavedCards: false,
        savedCards: [],
    };
    resetPledgePayOpenCredit();
}

function setPledgePayMemberContext(userId, data) {
    const uid = userId !== undefined && userId !== null ? String(userId).trim() : '';
    if (!uid) {
        resetPledgePayMemberContext();
        return;
    }
    if (pledgePayMemberContext.userId !== uid) {
        pledgePayMemberContext = {
            userId: uid,
            hasSavedCards: false,
            savedCards: [],
        };
        resetPledgePayOpenCredit();
    }
    if (!data || typeof data !== 'object') {
        return;
    }
    if (Array.isArray(data.savedCards)) {
        pledgePayMemberContext.savedCards = data.savedCards;
        pledgePayMemberContext.hasSavedCards = data.savedCards.length > 0;
        return;
    }
    if (typeof data.hasSavedCards === 'boolean') {
        pledgePayMemberContext.hasSavedCards = data.hasSavedCards;
    }
}

function getPledgePayMemberContext() {
    return pledgePayMemberContext;
}

export {
    resetPledgePayMemberContext,
    setPledgePayMemberContext,
    getPledgePayMemberContext,
};
